import { create } from "zustand";
import { persist } from "zustand/middleware";

export type TourId = "casePage" | "skyView";

export interface TourStep {
  id: string;
  target: string;
  titleKey: string;
  textKey: string;
  position: "top" | "bottom" | "left" | "right";
  tooltipAlign?: "start" | "center" | "end";
  arrowOffset?: number;
  advanceOnTargetClick?: boolean;
}

interface TourState {
  activeTour: TourId | null;
  currentStepIndex: number;
  completedTours: Record<TourId, boolean>;

  startTour: (tourId: TourId) => void;
  nextStep: () => void;
  skipTour: () => void;
  completeTour: () => void;
  resetTour: (tourId: TourId) => void;
  isTourCompleted: (tourId: TourId) => boolean;
}

export const useTourStore = create<TourState>()(
  persist(
    (set, get) => ({
      activeTour: null,
      currentStepIndex: 0,
      completedTours: {
        casePage: false,
        skyView: false,
      },

      startTour: (tourId: TourId) => {
        if (get().completedTours[tourId]) {
          return;
        }
        set({ activeTour: tourId, currentStepIndex: 0 });
      },

      nextStep: () => {
        set((state) => ({
          currentStepIndex: state.currentStepIndex + 1,
        }));
      },

      skipTour: () => {
        const { activeTour } = get();
        if (activeTour) {
          set((state) => ({
            activeTour: null,
            currentStepIndex: 0,
            completedTours: {
              ...state.completedTours,
              [activeTour]: true,
            },
          }));
        }
      },

      completeTour: () => {
        const { activeTour } = get();
        if (activeTour) {
          set((state) => ({
            activeTour: null,
            currentStepIndex: 0,
            completedTours: {
              ...state.completedTours,
              [activeTour]: true,
            },
          }));
        }
      },

      resetTour: (tourId: TourId) => {
        set((state) => ({
          completedTours: {
            ...state.completedTours,
            [tourId]: false,
          },
        }));
      },

      isTourCompleted: (tourId: TourId) => {
        return get().completedTours[tourId];
      },
    }),
    {
      name: "sky-onboarding-tour",
      partialize: (state) => ({
        completedTours: state.completedTours,
      }),
    }
  )
);
